import type { ShortcutKey } from '@/types';
import type { CommandPaletteItem } from '@/components/CommandPalette';

export const LAB_SHORTCUTS: readonly CommandPaletteItem<ShortcutKey>[] = [
  {
    value: '\\A',
    prefix: '\\',
    hotkey: 'A',
    label: 'View agenda',
    accent: '#16a34a',
  },
  {
    value: '\\C',
    prefix: '\\',
    hotkey: 'C',
    label: 'Change accounts',
    accent: '#f59e0b',
  },
];

export const PRACTICE_SHORTCUTS: readonly CommandPaletteItem<ShortcutKey>[] = [
  {
    value: '\\S',
    prefix: '\\',
    hotkey: 'S',
    label: 'New Case',
    accent: '#f15a2b',
  },
  {
    value: '\\P',
    prefix: '\\',
    hotkey: 'P',
    label: 'New Patient',
    accent: '#2e6bff',
  },
  {
    value: '\\T',
    prefix: '\\',
    hotkey: 'T',
    label: 'New task',
    accent: '#8b5cf6',
  },
  {
    value: '\\O',
    prefix: '\\',
    hotkey: 'O',
    label: 'New order',
    accent: '#0f9bb0',
  },
  ...LAB_SHORTCUTS,
];
